module.exports = __webpack_public_path__ + "img/T2A_rc_2.2bed05ba.png";